export const TEACHER_LIST = 'learning-center/create-teacher/TEACHER_LIST';
export const BATCH_CREATE_TEACHER = 'learning-center/create-teacher/BATCH_CREATE_TEACHER';



// WEBPACK FOOTER //
// ./src/store/modules/learning-center/create-teacher/types.js